The input parameter for the `applicationLibraryQuestionSuggestions` query.
